export const _UUID = '_UUID';